import {Label} from '@app/components/elements/Label';
import {
  CheckBoxOutlineBlank,
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';
import {
  BottomNavigation,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Paper,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useStyles} from './styles';
import {ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import { approvalStateSelector } from '@app/screens/campaign-management/pages/approval/redux/selectors';
import { approvalStateActions } from '@app/screens/campaign-management/pages/approval/redux/slice';

const CampaignFilter = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const getLeaveFilterDataSelector = useSelector(
    approvalStateSelector.getApprovalLandingFilters(),
    shallowEqual,
  );
  const approvalToggleState = useSelector(approvalStateSelector.getApprovalToggleState())
  const [filterComponents, setFilterComponent] = useState<any>(<></>);
  const [filters, setFiltersState] = useState<any>({});
  const addFilterView = () => {
    setFilterComponent(getFilterLayout(filters));
  };
  useEffect(() => {
    filters && Object.keys(filters)?.length > 0
      ? addFilterView()
      : setFilterComponent(<></>);
  }, [filters]);

  useEffect(() => {
    if (getLeaveFilterDataSelector && Object.keys(getLeaveFilterDataSelector)?.length > 0) {
      // Create a copy of the filter data
      const filtersCopy = JSON.parse(JSON.stringify(getLeaveFilterDataSelector));
      
      // For Campaign Name, ensure parent checkbox reflects child selections
      if (filtersCopy['Campaign Name'] && filtersCopy['Campaign Name'].filterData) {
        const hasSelectedCampaign = filtersCopy['Campaign Name'].filterData.some((item: any) => item.isChecked);
        filtersCopy['Campaign Name'].isChecked = hasSelectedCampaign;
      }
      
      setFiltersState(filtersCopy);
    } else {
      setFiltersState({});
    }
  }, [getLeaveFilterDataSelector]);

  const clearAllFilter = () => {
    setFiltersState(getLeaveFilterDataSelector);
  };

  const alterOptionFilterAppliedState = (
    state: any,
    parentKey: any,
    childKey: any,
  ) => {
    let filtersCopy = JSON.parse(JSON.stringify(filters ? filters : {}));
    if (filtersCopy[parentKey] && filtersCopy[parentKey].filterData) {
      filtersCopy[parentKey].filterData = filtersCopy[
        parentKey
      ].filterData?.map((optionKey: any) => {
        if (optionKey.id === childKey.id) {
          return {
            ...optionKey,
            isChecked: state,
          };
        }
        return optionKey;
      });
      const uncheckedChild = filtersCopy[parentKey]?.filterData?.find(
        (child: any) => !child?.isChecked,
      );
      filtersCopy[parentKey]['isChecked'] = getIsCheckedValue(uncheckedChild);
    }
    setFiltersState(filtersCopy);
  };

  const alterAllAppliedState = (state: any, key: any) => {
    let updatedFilters = JSON.parse(JSON.stringify(filters ? filters : {}));
    const parentFilter = updatedFilters[key];
    // Toggle the isChecked state of the parent
    parentFilter.isChecked = state;
    // Mark all child filters as checked or unchecked
    parentFilter.filterData.forEach((filter: any) => {
      filter.isChecked = state;
    });
    const replaceUpdateObj = {
      ...filters,
      [key]: parentFilter,
    };
    setTimeout(() => {
      setFiltersState(replaceUpdateObj);
    }, 0);
  };

  const getIsCheckedValue = (value: any) => {
    return value ? false : true;
  };

  const handleSingleSelection = (parentKeyName: string, selectedChild: any) => {
    let filtersCopy = JSON.parse(JSON.stringify(filters ? filters : {}));
    if (filtersCopy[parentKeyName] && filtersCopy[parentKeyName].filterData) {
      // Uncheck all options first
      filtersCopy[parentKeyName].filterData = filtersCopy[parentKeyName].filterData.map((option: any) => ({
        ...option,
        isChecked: false,
      }));
      
      // Check only the selected option
      filtersCopy[parentKeyName].filterData = filtersCopy[parentKeyName].filterData.map((option: any) => {
        if (option.id === selectedChild.id) {
          return {
            ...option,
            isChecked: true,
          };
        }
        return option;
      });
      
      // Set parent as checked since one child is selected
      filtersCopy[parentKeyName]['isChecked'] = true;
    }
    setFiltersState(filtersCopy);
  };

  const handleChildCheckbox = (parentKeyName: string, childKey: any) => {
    // For Campaign Name, ensure only single selection
    if (parentKeyName === 'Campaign Name') {
      handleSingleSelection(parentKeyName, childKey);
    } else {
      alterOptionFilterAppliedState(
        !childKey?.isChecked,
        parentKeyName,
        childKey,
      );
    }
  };

  const handleParentCheckbox = (parentKeyName: string, filter: any) => {
    // For Campaign Name, prevent parent checkbox from selecting all
    if (parentKeyName === 'Campaign Name') {
      // Do nothing - prevent multi-selection for Campaign Name
      return;
    }
    alterAllAppliedState(!filter?.isChecked, parentKeyName);
  };

  const checkIfIndeterminate = (list: any, filter: any, parentKeyName?: string) => {
    if (filter.isChecked) return false;
    
    // For Campaign Name, don't show indeterminate - just show checked/unchecked
    if (parentKeyName === 'Campaign Name') {
      return false;
    }
    
    let isIndeterminate = list?.find((item: any) => item.isChecked);
    return isIndeterminate ? true : false;
  };
  const handleAppleyedFilterOutput = () => {
    // Initialize empty lists
    const statusList: any[] = [];
    const leaveTypeList: any[] = [];
    const stateList: any[] = [];
    const divisionList: any[] = [];
    const userStatusList: any[] = [];
    const campaignList: any[] = [];
    // Iterate over each filter entry
    Object.entries<any>(filters).forEach(([key, value]) => {
      // Skip "Country" filter
      if (key === 'Country') return;
      // Extract filterData array and construct list based on key
      const list = value.filterData
        .filter((item: any) => item.isChecked)
        .map((item: any) => {
          if (key === 'Campaign status') {
            return {statusId: item.id};
          } else if (key === 'Campaign Name') {
            return {campaignId: item.id};
          } else if (key === 'Leave Type') {
            return {leaveTypeId: item.id};
          } else if (key === 'State') {
            return {stateId: item.id};
          } else if (key === 'Division') {
            return {divisionId: item.id};
          } else if (key === 'User Status') {
            return {userStatus: item.id};
          }
        });
      // Push constructed list to the respective list
      if (key === 'Campaign status') {
        statusList.push(...list);
      } else if (key === 'Campaign Name') {
        campaignList.push(...list);
      } else if (key === 'Leave Type') {
        leaveTypeList.push(...list);
      } else if (key === 'State') {
        stateList.push(...list);
      } else if (key === 'Division') {
        divisionList.push(...list);
      } else if (key === 'User Status') {
        userStatusList.push(...list);
      }
    });
    // Construct final output object
    const output: any = {
      statusList: statusList,
      campaignList: campaignList,
      leaveTypeList: leaveTypeList,
      stateList: stateList,
      divisionList: divisionList,
      userStatusList: userStatusList,
    };
    return output;
  };
  const applyFilters = () => {
    const output = handleAppleyedFilterOutput();
    // Check if no campaign is selected is
    if (output?.campaignList?.length === 0) {
      ToasterService.showToaster(
        'Please select at least one Campaign.',
        ToastType.ERROR,
      );
    } else if(output?.campaignList?.length < 1){
      ToasterService.showToaster(
        'Only One Campaign can be selected at a time.',
        ToastType.ERROR,
      );

    }
    else {
      // Use approval module's own action instead of leave management
      dispatch(approvalStateActions.setAppliedCampaignFilter(output));
    }
  };

  const getExpandIcon = (collapsed: boolean) => {
    if (collapsed) return <ExpandMore />;
    else return <ExpandLess />;
  };

  const listItemText = (text: string) => (
    <Label title={text} classes={classes.listItemText} />
  );

  const parentListItemText = (text: string) => (
    <Label title={text} classes={classes.parentListItemText} />
  );

  const getFilterLayout = (filtersObj: any) => {
    let filterItems: any = [];
    Object.keys(filtersObj).forEach(key => {
      filterItems.push(secondaryListItems(filtersObj[key], key));
    });
    return <Box paddingBottom={'100px'}>{filterItems}</Box>;
  };
  const handleParentListItemClick = (parentKeyName: string) => {
    let updatedZonesData = JSON.parse(JSON.stringify(filters ? filters : {}));
    updatedZonesData[parentKeyName].collapsed =
      !updatedZonesData[parentKeyName].collapsed;
    setFiltersState(updatedZonesData);
  };
  const secondaryListItems = (filter: any, parentKeyName: any) => {
    return (
      <>
        {filter ? (
          <Box marginBottom={'15px'} marginLeft={'10px'}>
            <ListItem
              disablePadding
              button
              key={parentKeyName}
              onClick={() => handleParentListItemClick(parentKeyName)}
              data-testid={`list_item_${parentKeyName}`}>
              <ListItemIcon>
                <Checkbox
                  className={classes.checkbox}
                  checked={filter?.isChecked || false}
                  indeterminate={checkIfIndeterminate(
                    filter?.filterData,
                    filter,
                    parentKeyName,
                  )}
                  disabled={filter?.isDisable || false}
                  indeterminateIcon={<IndeterminateIcon />}
                  onClick={event => {
                    handleParentCheckbox(parentKeyName, filter);
                  }}
                  data-testid={`parent_${parentKeyName}`}
                />
              </ListItemIcon>
              {parentListItemText(parentKeyName)}
              <Box paddingRight={'10px'}>
                {getExpandIcon(filter?.collapsed)}
              </Box>
            </ListItem>

            <Collapse in={!filter?.collapsed} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                className={classes.marginLeft15}>
                {filter?.filterData?.map((childKey: any) => {
                  return (
                    <>
                      <ListItem
                        disablePadding
                        button
                        key={`${parentKeyName}_${childKey?.id}`}
                        data-testid={`list_item_${childKey?.id}`}>
                        <ListItemIcon>
                          <Checkbox
                            className={classes.checkbox}
                            checked={childKey?.isChecked || false}
                            disabled={childKey?.isDisable || false}
                            indeterminateIcon={<IndeterminateIcon />}
                            onClick={event => {
                              handleChildCheckbox(parentKeyName, childKey);
                            }}
                            data-testid={`option_${parentKeyName}_${childKey?.id}`}
                          />
                        </ListItemIcon>
                        {listItemText(childKey?.value)}
                      </ListItem>
                    </>
                  );
                })}
              </List>
            </Collapse>
          </Box>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      <Box
        margin={'20px'}
        marginTop={'10px'}
        borderRadius={'20px'}
        className={`${classes.backgroundWhite} hide-scrollbar`}
        height={'100vh'}
        overflow={'scroll'}>
        {filters && Object.keys(filters)?.length > 0 ? (
          <>
            <Box
              display={'flex'}
              justifyContent="space-between"
              marginBottom={'10px'}
              padding={'10px'}>
              <Chip
                label="Filter"
                size="small"
                className={classes.chipFilter}
              />
              {/* <Chip
                label="Reset"
                size="small"
                clickable
                onClick={clearAllFilter}
                className={classes.chipClearAll}
                data-testid="clear-filters"
              /> */}
            </Box>

            {filterComponents}

            <Paper className={`${classes.paper} height-100`} elevation={3}>
              <BottomNavigation showLabels value={0}>
                <Box className={classes.applyBox}>
                  <Button
                    variant="contained"
                    onClick={applyFilters}
                    className={classes.paperButton}
                    data-testid={'apply_filters'}>
                    Apply
                  </Button>
                </Box>
              </BottomNavigation>
            </Paper>
          </>
        ) : (
          <Box sx={{display: 'flex', justifyContent: 'center', mt: 2}}>
            <CircularProgress size={20} />
          </Box>
        )}
      </Box>
    </>
  );
};

const IndeterminateIcon = () => {
  const classes = useStyles();

  return (
    <>
      <CheckBoxOutlineBlank />
      <div className={classes.indeterminateBox} />
    </>
  );
};

export default CampaignFilter;
